<template>
  <div class="flex max-h-[80vh] flex-col space-y-3 overflow-auto">
    <draggable
      v-model="whitelabels"
      ghost-class="ghost"
      class="space-y-4"
      item-key="id"
      handle=".drag-handle"
      data-cy="blocks-draggable"
      @dragstart="handleDragStart"
      @dragend="handleDragEnd"
    >
      <template #item="{ element }: { element: IWhitelabel }">
        <whitelabel-card
          :whitelabel="element"
          :data-id="element.id"
          data-cy="whitelabel-card"
          class="cursor-pointer hover:bg-blue-50"
          :class="{
            'border-blue-500 bg-blue-100': activeWhitelabel?.id === element.id,
          }"
          @click="emit('whitelabel:click', element)"
          @whitelabel:delete="emit('whitelabel:delete', element)"
        >
          <template #drag-handle>
            <button
              v-if="element.id && validWhitelabels.length > 1"
              class="drag-handle handle-button flex items-center justify-center px-2-5 py-3-5 transition-opacity"
              data-cy="block-drag-handle"
              @click.stop
            >
              <icon-base
                class="h-3 w-2 text-gray-400"
                height="12"
                width="7"
                :icon="IconDragHandle"
                viewBox="0 0 12 20"
              />
            </button>
          </template>
        </whitelabel-card>
      </template>
    </draggable>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import draggable from "vuedraggable";

import IconDragHandle from "@/components/icons/IconDragHandle.vue";
import WhitelabelCard from "@/views/profile/emailIntegration/WhitelabelCard.vue";

import type { IWhitelabel } from "@/models/clients";

const { activeWhitelabel } = defineProps<{
  activeWhitelabel: IWhitelabel | null;
}>();

const whitelabels = defineModel<IWhitelabel[]>("whitelabels", {
  required: true,
});

const emit = defineEmits<{
  "whitelabel:click": [whitelabel: IWhitelabel];
  "whitelabel:delete": [whitelabel: IWhitelabel];
  "whitelabel:reorder": [whitelabels: IWhitelabel[]];
}>();

const validWhitelabels = computed(() =>
  whitelabels.value.filter(({ id }) => !!id)
);

const handleDragStart = (event: DragEvent) => {
  const target = event.target as HTMLElement | null;
  target?.classList.add("dragging");
};

const handleDragEnd = (event: DragEvent) => {
  const target = event.target as HTMLElement | null;
  target?.classList.remove("dragging");
  emit("whitelabel:reorder", whitelabels.value);
};
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.ghost {
  @apply border-2 border-dashed border-silver opacity-50;
}

.dragging .handle-button {
  @apply bg-grey-hover;
}
</style>
